module.exports = __webpack_public_path__ + "static/media/mess3.a1d21b91.png";